import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          none_negative_carryover: {
            header: 'HEADER',
            save: 'SUBMIT',
            form: {
              merchant_name: 'MERCHANT_NAME_LABEL',
              enable_nnco: 'ENABLE_NNCO_LABEL',
              enable_nnco_options: {
                yes: 'ENABLE_NNCO_YES',
                no: 'ENABLE_NNCO_NO',
              },
              date: 'DATE_LABEL',
            },
          },
        },
      },
    },
  }));
}
